import './tracing';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './lib/AppProvider';
import { domain } from './domain';

const root = ReactDOM.createRoot(document.getElementById('root'));
let needsRedirect = false;

console.info("DEVELOPMENT-ENVIRONMENT: ", process.env.REACT_APP_DEVELOPMENT_ENVIRONMENT);

if (domain.redirectSubDomain && domain.redirectSubDomain !== domain.subDomain) {
    needsRedirect = true;
    let newLocation = `${window.location.protocol}//${domain.redirectSubDomain}.${window.location.host}${window.location.pathname}${window.location.search}`;

    // Azure devops doesn't allow subdomains so we will do this workaround
    if (newLocation.indexOf(`${domain.redirectSubDomain}.dev-ucauth.azurewebsites.net`))
    {
        if (newLocation.indexOf(`subdomain=${domain.redirectSubDomain}`)) {
            needsRedirect = false;
        }
        if (needsRedirect)
        {
            newLocation = `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}&subdomain=${domain.redirectSubDomain}`;
        }
    }

    if (needsRedirect) {
        window.location = newLocation;
    }
}

root.render(
    <>
    {needsRedirect &&
        <div>Redirecting...</div>
    }
    {!needsRedirect &&
            <BrowserRouter>
                <AppProvider>
                    <App />
                </AppProvider>
            </BrowserRouter>
    }
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
